import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import "./DifferenceTools.css";
import { Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { ReactComponent as CheckGreen } from "../../Icons/checkGreen.svg";
import { ReactComponent as CheckRed } from "../../Icons/CheckRed.svg";
import { ReactComponent as CheckBlue } from "../../Icons/CheckBlue.svg";

function XMLMultiDiffViewer() {

    const location = useLocation();
    const [activeIndex, setActiveIndex] = useState(0);

    const {
        comparisons = {},
    } = location.state || {};

    const results = Object.entries(comparisons || {});
    const activeComparison = results[activeIndex]?.[1] || {};

    const getTypeClass = (type) => {

        switch (type) {

            case "TEXT_DIFF":
                return "xml-diff-text";

            case "MISSING_NODE":
                return "xml-diff-missing";

            case "EXTRA_NODE":
                return "xml-diff-extra";

            case "ATTRIBUTE_DIFF":
                return "xml-diff-attribute";

            default:
                return "";
        }
    };

    /* =========================
       TYPE LABEL
    ========================= */

    const getTypeLabel = (type) => {

        switch (type) {

            case "TEXT_DIFF":
                return "TEXT-DIFF";

            case "MISSING_NODE":
                return "MISSING-NODE";

            case "EXTRA_NODE":
                return "EXTRA-NODE";

            case "ATTRIBUTE_DIFF":
                return "ATTRIBUTE-DIFF";

            default:
                return type;
        }
    };

    return (
        <Col>

            {/* =========================
                HEADER
            ========================= */}

            <ToolHeader title="Comparison Results" description="Compare a base XML with multiple XML inputs" showFavourite={false} />

            {/* =========================
                SUMMARY
            ========================= */}

            <Row className="ActionButtons diff-action-buttons">

                {results.map(([key, item], index) => (

                    <Col
                        key={key}
                        onClick={() => setActiveIndex(index)}
                        className={`ActionButton diff-action-button ${activeIndex === index ? "active" : ""
                            }`}
                        style={{
                            cursor: "pointer",
                            backgroundColor:
                                activeIndex === index
                                    ? "#4F3CFA1A"
                                    : ""
                        }}
                    >

                        <span style={{ color: "var(--text-color)" }}>
                            XML {index + 2}
                        </span>

                        <span
                            style={{
                                color: "#21C55E",
                                padding: "4px 8px"
                            }}
                        >
                            {item.nodeDiffCount || 0} nodes
                        </span>

                        <span
                            style={{
                                color: "#EF4444",
                                padding: "4px 8px"
                            }}
                        >
                            {item.attributeDiffCount || 0} attrs
                        </span>

                        <span
                            style={{
                                color: "#3B82F6",
                                padding: "4px 8px"
                            }}
                        >
                            {item.textDiffCount || 0} text
                        </span>

                    </Col>

                ))}

            </Row>

            {/* =========================
                LEGEND
            ========================= */}

            <Row className="Introduction-Header align-items-center">

                <Col md={6} className="diff-legend">

                    <span style={{ color: "#21C55E" }}>
                        <CheckGreen /> Missing nodes
                    </span>

                    <span style={{ color: "#EF4444" }}>
                        <CheckRed /> Attributes
                    </span>

                    <span style={{ color: "#3B82F6" }}>
                        <CheckBlue /> Text content diffs
                    </span>

                </Col>

                <Col
                    md={6}
                    className="DiffoutputToggleWraper d-flex justify-content-end"
                >

                    {results.map((_, idx) => (

                        <div
                            key={idx}
                            className={`DiffoutputToggle ${activeIndex === idx ? "active" : ""
                                }`}
                            style={{
                                backgroundColor:
                                    activeIndex === idx
                                        ? "#5B4CFF"
                                        : "",
                                cursor: "pointer"
                            }}
                            onClick={() => setActiveIndex(idx)}
                        >
                            XML {idx + 2}
                        </div>

                    ))}

                </Col>

            </Row>
           
            <div className="csv-total-badge">
                {activeComparison.differences?.length || 0} total
            </div>

            <div className="csv-diff-wrapper">

                {activeComparison?.differences?.map((diff, idx) => (

                    <div
                        key={idx}
                        className={`csv-diff-card ${getTypeClass(diff.type)}`}
                    >

                        {/* HEADER */}

                        <div className="csv-diff-header align-items-start">

                            <div className="csv-diff-path-wrapper">

                                {/* PATH */}

                                <div className="csv-diff-path">
                                    {diff.path}
                                </div>
                            </div>
                            <div className="csv-diff-type">
                                {getTypeLabel(diff.type)}
                            </div>

                        </div>
                        <div className="csv-diff-content">

                            {/* BASE */}

                            <div className="csv-diff-box-wrapper">

                                <div className="csv-diff-box-title">
                                    BASE
                                </div>

                                <div className="csv-diff-box">
                                    {diff.baseValue || "-"}
                                </div>

                            </div>

                            {/* COMPARE */}

                            <div className="csv-diff-box-wrapper">

                                <div className="csv-diff-box-title">
                                    COMPARE
                                </div>

                                <div className="csv-diff-box">
                                    {diff.compareValue || "-"}
                                </div>

                            </div>

                        </div>

                    </div>

                ))}

            </div>

        </Col>
    );
}

export default XMLMultiDiffViewer;
